export default "__VITE_ASSET__CVRBs6dC__"